/**
 * Search through a nested object to find a category by its path
 *
 * @param {Array} categories
 * @param {string} path
 * @returns {boolean}
 */
export function findCategoryByPath(categories, path) {
    for (const category of categories) {
        if (category.path === path) {
            return category
        }

        if (category.children) {
            const result = findCategoryByPath(category.children, path)
            if (result) {
                return result
            }
        }
    }

    return null
}

/**
 * Search through a nested object to find a category by its id
 *
 * @param {Array} categories
 * @param {number} id
 * @returns {boolean}
 */
export function findCategoryById(categories, id) {
    for (const category of categories) {
        if (category.id === id) {
            return category
        }

        if (category.children) {
            const result = findCategoryById(category.children, id)
            if (result) {
                return result
            }
        }
    }

    return null
}

/**
 * Returns the categories leading up to the given category
 * eg. for breadcrumbs
 *
 * @param {Array} categories
 * @param {string} path
 * @returns {Array}
 */
export function getCategoriesByPath(categories, path) {
    const output = []
    const currentPath = []

    for (const part of path.split('/')) {
        currentPath.push(part)

        output.push(findCategoryByPath(categories, currentPath.join('/')))
    }

    return output
}

/**
 * Flatten a nested category object into a flat array
 *
 * @param {Array} categories
 * @returns {Array}
 */
export function getCategoriesFlat(categories) {
    const output = []

    for (const category of categories) {
        output.push(category)

        if (category.children) {
            output.push(...getCategoriesFlat(category.children))
        }
    }

    return output
}

/**
 * Returns the parent category
 *
 * @param {Array} categories
 * @param path
 * @returns {Array}
 */
export function getParentCategoryByPath(categories, path) {
    const parts = path.split('/')
    parts.pop()

    return findCategoryByPath(categories, parts.join('/'))
}

export const __createSegmentCategoryMapping = (
    categoryPath,
    returnObject = false
) => {
    if (!categoryPath) return {}
    const categoryParts = categoryPath.split('/')
    let categoryTrackingObject = {}

    const categoryTrackingMapping = categoryParts.map((categorySlug, depth) => {
        const items = {
            ...(depth === 0 && { mainCategory: categorySlug }),
            ...(depth === 1 && { sub: categorySlug }),
            ...(depth === 2 && { subsub: categorySlug }),
            [`level${depth + 1}Category`]: categorySlug,
        }
        categoryTrackingObject = { ...categoryTrackingObject, ...items }
        return items
    })

    if (returnObject) {
        return categoryTrackingObject
    }

    return categoryTrackingMapping
}
